'use strict';
const angular = require('angular');
const moment = require('moment');
const uiRouter = require('angular-ui-router');

import routes from './survey-show.routes';

export class SurveyShowComponent {
  constructor($stateParams, SurveysService, $uibModal, $window, DTOptionsBuilder, User, SettingsService, PropertyService,
              $location, VoterGroupsService, HistoryService, SurveyResultsService, $filter, dialogs) {
    'ngInject';

    this.back = _ => $window.history.back();
    this.$filter = $filter;

    this.surveyId = $stateParams.id;
    this.$uibModal = $uibModal;
    this.$location = $location;
    this.dialogs = dialogs;

    this.cursor = 0;
    this.maxCursor = 0;
    this.totalVotings = 0;
    this.form = ["*"];

    this.SurveysService = SurveysService;
    this.PropertyService = PropertyService;
    this.VoterGroupsService = VoterGroupsService;
    this.SurveyResultsService = SurveyResultsService;

    this.mapPropertyParticipant = {};

    this.mapKeyResponseCount = {};
    this.mapKeyResponseStats = {};

    this.filteredFields = [];

    SettingsService.getByName({name: 'client'}, settings => {
      this.useSuite = settings.data.useSuite;
      this.hasBuildingNo = settings.data.buildingNoVisible;

      this.refreshData();
    });

    this.chartOptionsStartFromZero = {
      scales: {
        xAxes: [{
          ticks: {
            beginAtZero: true
          }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      }
    };

  }

  getPrimaryOwnerId(contacts) {
    if (!contacts) return 0;

    let primary = contacts.find(contact => contact.type == 'primary-owner');

    if (!primary) // No Primary Owner
      return 0;
    else if (!primary.contact || !primary.contact._id) // Contact for Primary Owner deleted
      return -1;
    else
      return primary.contact._id;
  }

  getPrimaryOwner(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let primary = contacts.find(contact => contact.type == 'primary-owner');

    if (!primary)
      return "-";

    return this.getComposedName(primary.contact);
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "") {
        composedName += contact.company;
      } else {
        composedName += "<br/>" + contact.company;
      }
    }

    return composedName;
  }

  refreshData() {
    this.dataInitComplete = false;

    if (this.surveyId) {
      this.SurveysService.get({id: this.surveyId}, data => {
        this.survey = data;
        this.schema = this.survey.formSchema;
        this.filteredFields = this.survey.fields.filter(field => !field.hideFieldInResult);

        this.deadlineReached = this.survey.deadline && moment(this.survey.deadline).isBefore(moment());

        let VG_QUERY_METHOD = (this.useSuite) ? "getWithDataSuite" : "getWithData";
        this.VoterGroupsService[VG_QUERY_METHOD]({id: this.survey.voterGroup}, vg => {

          this.survey.voterGroup = vg;
          this.voters = vg.properties;

          this.SurveyResultsService.getBySurvey({id: this.surveyId}, results => {

            this.results = results.reverse();

            if (!results.length) {
              this.dataInitComplete = true;
              return;
            }

            this.maxCursor = this.results.length ? this.results.length - 1 : 0;
            this.move("first");

            this.mapPropertyParticipant = {};
            this.results.forEach(result => {
              this.mapPropertyParticipant[result.property] = {
                creationDate: result.meta.creationDate,
                participant: result.participantPlain
              }
            });

            // do the dump of all answers
            this.mapKeyResponseCount = {};
            this.mapKeyResponseDump = {};
            this.results.forEach(result => {
              let data = result.data;

              this.survey.fields.forEach(field => {
                let entry = data[field.key];

                if (!this.mapKeyResponseCount[field.key]) {
                  this.mapKeyResponseDump[field.key] = [];
                  this.mapKeyResponseCount[field.key] = [];
                }

                this.mapKeyResponseDump[field.key].push(entry);
              })
            });

            // do the math
            this.survey.fields.forEach(field => {

              if (field.type == 'ranking') {
                // we want to average position in the array as score

                let stats = {};

                this.mapKeyResponseDump[field.key].forEach(ranking => {
                  ranking.forEach((item, index) => {
                    if (!stats[item]) {
                      stats[item] = { total: 0, count: 0 };
                    }
                    stats[item].total += index + 1; // +1 to make position start from 1
                    stats[item].count += 1;
                  });
                });

                const averages = Object.entries(stats).map(([item, { total, count }]) => {
                  return [item, total / count];
                });

                this.mapKeyResponseCount[field.key] = averages.sort((a, b) => a[1] - b[1]);

              } else if (field.type == 'number') {

                // Frequency count
                let countMap = {};

                let validNumberSubmissions = this.mapKeyResponseDump[field.key].filter(x => x !== null && x !== undefined );
                let emptySubmissions = this.mapKeyResponseDump[field.key].filter(x => x === null || x === undefined ).length;

                validNumberSubmissions.forEach(num => {
                  countMap[num] = (countMap[num] || 0) + 1;
                });

                const frequencyArray = Object.entries(countMap)
                  .map(([num, count]) => [Number(num), count])
                  .sort((a, b) => b[1] - a[1]);

                let stats = {};

                // Min and Max
                stats.min = Math.min(...validNumberSubmissions);
                stats.max = Math.max(...validNumberSubmissions);

                // Average (mean)
                stats.sum = validNumberSubmissions.reduce((acc, num) => acc + num, 0);
                stats.average = stats.sum / validNumberSubmissions.length;

                // Median
                const sorted = [...validNumberSubmissions].sort((a, b) => a - b);
                const mid = Math.floor(sorted.length / 2);
                stats.median =
                  sorted.length % 2 === 0
                    ? (sorted[mid - 1] + sorted[mid]) / 2
                    : sorted[mid];

                // Mode (most frequent number(s))
                try {
                  const maxCount = frequencyArray[0][1];
                  stats.mode = frequencyArray
                    .filter(([_, count]) => count === maxCount)
                    .map(([num]) => Number(num));
                } catch(e) {
                  console.error(e);
                  stats.mode = [];
                }

                this.mapKeyResponseStats[field.key] = stats;

                frequencyArray.push([null, emptySubmissions]);

                this.mapKeyResponseCount[field.key] = frequencyArray.sort((a,b) => b[1] - a[1]);

              } else {
                // we want to count/number of occurrences in the array, for all the other types

                let keyMap = {};

                if (field.type == 'select') {
                  field.enum.forEach(entry => keyMap[entry] = 0);
                }

                if (field.type == 'yes/no') {
                  keyMap = {true: 0, false: 0}
                }

                this.mapKeyResponseDump[field.key].forEach(entry => keyMap[entry] = (keyMap[entry] || 0) + 1);
                this.mapKeyResponseCount[field.key] = Object.entries(keyMap).sort((a,b) => b[1] - a[1]);
              }
            });

            this.dataInitComplete = true;
          });

        });

      }, err => {
        console.log('Could not load survey from server');
      });
    }
  }

  sendCampaignEmail() {

    let that = this;

    var dlgCtrl = function ($scope, $uibModalInstance) {
      // Initialize checkbox values
      $scope.eVotingConsent = false;
      $scope.eContactConsent = true;

      $scope.msg = "<h4><b>"+  that.survey.campaign.mailSubject +"</b></h4><hr/>"+that.survey.campaign.mailText

      $scope.cancel = function(){
        $uibModalInstance.dismiss('Canceled');
      }; // end cancel

      $scope.confirm = function(){
        $uibModalInstance.close({
          eVotingConsent: $scope.eVotingConsent,
          eContactConsent: $scope.eContactConsent
        });
      };
    };

    var dlg = this.dialogs.create('app/survey/show/campaign-send-confirmation.html',dlgCtrl,{},{size:'lg',keyboard: true,backdrop: false,windowClass: 'my-class'});
    dlg.result.then(restrictions => {
      this.SurveysService.sendCampaignMail({id: this.surveyId}, {restrictions: restrictions}, _ => {
        this.dialogs.notify("Success", "The Campaign Email has been sent successfully");
      }, err => {
        console.log(err);
      })
    },() => {
      // Cancel
    });

    /*
    var dlg = this.dialogs.confirm("Send Campaign Email?", "<h4><b>"+  this.survey.campaign.mailSubject +"</b></h4><hr/>"+this.survey.campaign.mailText);
    dlg.result.then(() => {
      this.SurveysService.sendCampaignMail({id: this.surveyId}, {}, _ => {
        this.dialogs.notify("Success", "The Campaign Email has been sent successfully");
      }, err => {
        console.log(err);
      })
    }, () => {
      // Cancel
    });

     */
  }

  move(pos) {
    switch (pos) {
      case 'first':
        this.cursor = 0;
        break;
      case 'prev':
        this.cursor--;
        break;
      case 'next':
        this.cursor++;
        break;
      case 'last':
        this.cursor = this.maxCursor;
        break;
    }

    this.model = this.results[this.cursor];
  }

}

export default angular.module('conduu.survey.show', [uiRouter])
  .config(routes)
  .component('surveyShow', {
    template: require('./survey-show.html'),
    controller: SurveyShowComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/survey/show/survey-show.component.js